import type { RouteRecordRaw } from 'vue-router'
import { AppModule } from '@/config/types'
import { SmsSurveyRoutes } from '@/routes/user/sms-survey/types'
import { getSmsSurveysBuilderRoutes, getSmsSurveysDetailsRoutes } from '@/routes/user/sms-survey/smsSurveysDetails'

export const getSmsSurveysRoutes = (): RouteRecordRaw[] => [
  {
    name: SmsSurveyRoutes.index,
    path: 'sms-surveys',
    redirect: { name: SmsSurveyRoutes.overview },
    children: [
      {
        name: SmsSurveyRoutes.overview,
        path: '',
        meta: {
          tabTitle: 'pageTabTitle.user.services.smsSurveys',
          modules: [AppModule.SmsSurveys],
        },
        component: () => import('@/components/views/services/smsSurveys/SmsSurveysNew.vue'),
      },
      ...getSmsSurveysDetailsRoutes(),
      ...getSmsSurveysBuilderRoutes(),
    ],
  },
]
